<div class="popup marginBottomStyle" cdkDrag cdkDragRootElement=".cdk-overlay-pane"
    style="position: relative; overflow: hidden; height: 100%">
    <div cdkDragHandle>
        <label i18n="@@spmsUserReg" class="textColour">Object Relationship</label>
        <span class="example-spacer"></span>
    </div>
    <div style="height: 83%; overflow: hidden">
        <div style="height: 98%; overflow: auto">
            <form novalidate [formGroup]="formValid" style="margin-bottom: 3em">
                <div class="container">
                    <div style="max-width: 0; max-height: 0; overflow: hidden">
                        <input autofocus="true" />
                    </div>
                    <div class="row topRowMargins">
                        <div class="col-lg-1"></div>
                        <div class="col-lg-10">
                            <mat-form-field appearance="outline">
                                <mat-label i18n="@@targetloginusername">
                                    Object Name
                                </mat-label>
                                <mat-select formControlName="objectName" [(ngModel)]="objectNameValue" required (ngModelChange)="onObjectNameChange($event)">
                                    <mat-option>None</mat-option>
                                        <mat-option *ngFor="let tempObject of objectsList" [value]="tempObject.id" [disabled]="tempObject.isDisabledObject">
                                            {{tempObject.objectname}}
                                        </mat-option>

                                </mat-select>
                                <mat-error *ngFor="let validation of validation_messages.objectName">
                                    <span
                                        *ngIf="formValid.get('objectName').hasError(validation.type) && (formValid.get('objectName').dirty || formValid.get('objectName').touched)">
                                        {{ validation.message }}
                                    </span>
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg-1"></div>
                    </div>
                    <div class="row topRowMargins">
                        <div class="col-lg-1"></div>
                        <div class="col-lg-10">
                            <mat-form-field appearance="outline">
                                <mat-label i18n="@@targetloginusername">
                                   Parent Object Name
                                </mat-label>
                                <mat-select formControlName="parentObjectName" [(ngModel)]="parentObjectNameValue" required (ngModelChange)="onparentObjectNameChange($event)">
                                    <mat-option>None</mat-option>
                                    <mat-option *ngFor="let tempObject of objectsList" [value]="tempObject.id" [disabled]="tempObject.isDisabledParentObject">
                                        {{tempObject.objectname}}
                                    </mat-option>

                                </mat-select>
                                <mat-error *ngFor="let validation of validation_messages.parentObjectName">
                                    <span
                                        *ngIf="formValid.get('parentObjectName').hasError(validation.type) && (formValid.get('parentObjectName').dirty || formValid.get('parentObjectName').touched)">
                                        {{ validation.message }}
                                    </span>
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg-1"></div>
                    </div>
                    <div class="row topRowMargins">
                        <div class="col-lg-1"></div>
                        <div class="col-lg-10">
                            <mat-form-field appearance="outline">
                                <mat-label i18n="@@targetloginusername">
                                    Unique Key Column
                                </mat-label>
                                <input matInput type="text" formControlName="uniqueKeyColumn"
                                    [(ngModel)]="vaultObjectRelationshipObject.uniqueKeyColumn" placeholder="You can add multiple values separated by commas." required />
                                <mat-error *ngFor="let validation of validation_messages.uniqueKeyColumn">
                        <span
                            *ngIf="formValid.get('uniqueKeyColumn').hasError(validation.type) && (formValid.get('uniqueKeyColumn').dirty || formValid.get('uniqueKeyColumn').touched)">
                            {{ validation.message }}
                        </span>
                    </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg-1"></div>
                    </div> 
                    <div class="row topRowMargins">
                        <div class="col-lg-1"></div>
                        <div class="col-lg-10">
                            <mat-form-field appearance="outline">
                                <mat-label i18n="@@targetloginusername">
                                    Columns From Parent File
                                </mat-label>
                                <input matInput type="text" formControlName="columnsFromParentFile"
                                    [(ngModel)]="vaultObjectRelationshipObject.columnsFromParentFile" placeholder="You can add multiple values separated by commas." required />
                                <mat-error *ngFor="let validation of validation_messages.columnsFromParentFile">
                        <span
                            *ngIf="formValid.get('columnsFromParentFile').hasError(validation.type) && (formValid.get('columnsFromParentFile').dirty || formValid.get('columnsFromParentFile').touched)">
                            {{ validation.message }}
                        </span>
                    </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg-1"></div>
                    </div> 
                    <div class="row topRowMargins">
                        <div class="col-lg-1"></div>
                        <div class="col-lg-10">
                            <mat-form-field appearance="outline">
                                <mat-label i18n="@@targetloginusername">
                                    Parent Ref Column
                                </mat-label>
                                <input matInput type="text" formControlName="parentRefColumn"
                                    [(ngModel)]="vaultObjectRelationshipObject.parentRefColumn" required />
                                <mat-error *ngFor="let validation of validation_messages.parentRefColumn">
                        <span
                            *ngIf="formValid.get('parentRefColumn').hasError(validation.type) && (formValid.get('parentRefColumn').dirty || formValid.get('parentRefColumn').touched)">
                            {{ validation.message }}
                        </span>
                    </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg-1"></div>
                    </div> 
                    <div class="row topRowMargins">
                        <div class="col-lg-1"></div>
                        <div class="col-lg-10">
                            <mat-form-field appearance="outline">
                                <mat-label i18n="@@targetloginusername">
                                    Parent File Name
                                </mat-label>
                                <input matInput type="text" formControlName="parentFileName"
                                    [(ngModel)]="vaultObjectRelationshipObject.parentFileName" required />
                                <mat-error *ngFor="let validation of validation_messages.parentFileName">
                        <span
                            *ngIf="formValid.get('parentFileName').hasError(validation.type) && (formValid.get('parentFileName').dirty || formValid.get('parentFileName').touched)">
                            {{ validation.message }}
                        </span>
                    </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg-1"></div>
                    </div>
                    <div class="row topRowMargins">
                        <div class="col-lg-1"></div>
                        <div class="col-lg-10">
                            <mat-form-field appearance="outline">
                                <mat-label i18n="@@targetloginusername">
                                    Child File Name
                                </mat-label>
                                <input matInput type="text" formControlName="childFileName"
                                    [(ngModel)]="vaultObjectRelationshipObject.childFileName" required />
                                <mat-error *ngFor="let validation of validation_messages.childFileName">
                        <span
                            *ngIf="formValid.get('childFileName').hasError(validation.type) && (formValid.get('childFileName').dirty || formValid.get('childFileName').touched)">
                            {{ validation.message }}
                        </span>
                    </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg-1"></div>
                    </div>
                    <div class="row topRowMargins">
                        <div class="col-lg-1"></div>
                        <div class="col-lg-10">
                            <mat-form-field appearance="outline">
                                <mat-label i18n="@@targetloginusername">
                                    Uniquekey Column D2D Validation
                                </mat-label>
                                <input matInput type="text" formControlName="uniquekeycolumnd2dvalidation"
                                placeholder="You can add multiple values separated by commas." [(ngModel)]="vaultObjectRelationshipObject.uniquekeycolumnd2dvalidation" />
                                <mat-error *ngFor="let validation of validation_messages.uniquekeycolumnd2dvalidation">
                        <span
                            *ngIf="formValid.get('uniquekeycolumnd2dvalidation').hasError(validation.type) && (formValid.get('uniquekeycolumnd2dvalidation').dirty || formValid.get('uniquekeycolumnd2dvalidation').touched)">
                            {{ validation.message }}
                        </span>
                    </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg-1"></div>
                    </div>
                    <div class="row topRowMargins">
                        <div class="col-lg-1"></div>
                        <div class="col-lg-10">
                            <mat-form-field appearance="outline">
                                <mat-label i18n="@@targetloginusername">
                                   Reference Column Mapping
                                </mat-label>
                                <input matInput type="text" formControlName="refcolmapping"
                                 [(ngModel)]="vaultObjectRelationshipObject.refcolmapping" />
                                <!-- <mat-error *ngFor="let validation of validation_messages.uniquekeycolumnd2dvalidation">
                        <span
                            *ngIf="formValid.get('uniquekeycolumnd2dvalidation').hasError(validation.type) && (formValid.get('uniquekeycolumnd2dvalidation').dirty || formValid.get('uniquekeycolumnd2dvalidation').touched)">
                            {{ validation.message }}
                        </span>
                    </mat-error> -->
                            </mat-form-field>
                        </div>
                        <div class="col-lg-1"></div>
                    </div>
                    <div class="row topRowMargins">
                        <div class="col-lg-1"></div>
                        <div class="col-lg-10">
                            <mat-form-field appearance="outline">
                                <mat-label i18n="@@targetloginusername">
                                   Primary Column
                                </mat-label>
                                <input matInput type="text" formControlName="primarycolumn"
                                 [(ngModel)]="vaultObjectRelationshipObject.primarycolumn" />
                                <!-- <mat-error *ngFor="let validation of validation_messages.uniquekeycolumnd2dvalidation">
                        <span
                            *ngIf="formValid.get('uniquekeycolumnd2dvalidation').hasError(validation.type) && (formValid.get('uniquekeycolumnd2dvalidation').dirty || formValid.get('uniquekeycolumnd2dvalidation').touched)">
                            {{ validation.message }}
                        </span>
                    </mat-error> -->
                            </mat-form-field>
                        </div>
                        <div class="col-lg-1"></div>
                    </div>
                    </div>
                    </form>

            </div>
        </div>

    <div class="row mb-1 topRowMargins" style= "position:sticky;left:0;bottom:0;width:100%">

        <div class="col-lg text-center" >

            <div style="text-align: end">

                <form novalidate [formGroup]="formValidCheckbox">

                    <span *ngIf="showCreateAnother">

                        <mat-checkbox formControlName="isCheckboxSelected" [(ngModel)]="isCheckboxSelected" style="margin-right:1%" class="mat-checkbox-layout"></mat-checkbox>

                        <span>

                            Create another

                        </span>

                    </span>
                    
                    <button i18n="@@TargetClear" type="button" (click)="sendDataAndClose()"
                    class="actionButton btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
                    style="padding-left:1.2rem;padding-right: 1.2rem" [style.background-color]="backgroundColorButton" [class.allocateButtons]="allocateButtonsBoolean" [class.allocateButtons1]="allocateButtons1Boolean">{{buttonName}}</button>

                    <button i18n="@@TargetCancel" type="button" (click)="closeFunction()"
                    class="cancelButton btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
                    style="padding-left:1.2rem;padding-right: 1.2rem" [style.border-color]="backgroundColorButton" [class.allocateButtons]="allocateButtonsBoolean" [class.allocateButtons1]="allocateButtons1Boolean" >Cancel</button>        

                </form>

            </div>
 
        </div>
        
    </div>
    </div>